import Pitch from "./Pitch";
import "./Map.scss";

const Map = ({
  data,
  children = null,
  onMouseDownHandler = () => {},
  onMouseMoveHandler = () => {},
  onMouseUpHandler = () => {},
  ...rest
}) => {
  return (
    <div className="map-container">
      <Pitch
        data={data}
        onMouseDownHandler={onMouseDownHandler}
        onMouseMoveHandler={onMouseMoveHandler}
        onMouseUpHandler={onMouseUpHandler}
        {...rest}
      >
        {children}
      </Pitch>
    </div>
  );
};

export default Map;
